import { 
    ApproverLookupLayout,
    IDCodesLookupLayout,
    IDContactLookupLayout,
    IDCustomerWithQuickAddLookupLayout,
    IDDriverLookupLayout,
    IDEquipmentLookupLayout,
    IDLookupLayout,
    IDParticipantLookupLayout,
    IDShipperLookupLayout,
    IDShipToLookupLayout,
    IDWarehouseLookupLayout,
    NotifyPartyLookupLayout,
    PatronLookupLayout} from "../../../../common/lookups/Layouts/IdLayouts"
import { OMProfileLayout } from "../../../../common/lookups/Layouts/OMLayouts";
import Form from "../../../../wm/components/quickadd/customer/Form";
import MainTab from '../../../../id/codes/customerDataEntry/MainTab';
import { OMCodesLookupLayout } from '../../../../common/lookups/Layouts/OMLayouts';
import { IDShipViaLookupLayout,IDTaxHeaderLookupLayout,IDSynonymsLookupLayout,IDTermCodeLookupLayout
,IDDiscountHeaderLookupLayout} from "../../../../common/lookups/Layouts/IdLayouts"
import { AccountLookup, ACDepartmentLayout } from "../../../../common/lookups/Layouts/ACLayouts"
import { FAFundLayout } from "../../../../common/lookups/Layouts/FALayouts"
import { CAJobLayout } from "../../../../common/lookups/Layouts/CALayouts"
import { FMLayouts } from "../../../../common/lookups/Layouts/FMLayouts";
import { CodeLookup } from "../../../../common/lookups/Layouts/SPLayouts";
import { ZoneTabelCodeLookup } from "../../../../common/lookups/Layouts/RTLayouts";

const reasonCode = OMCodesLookupLayout({codeType: '01' });
const customerLayout = IDCustomerWithQuickAddLookupLayout({
    onCustomItemCreatingComponent: MainTab,
    IdType:"01",
  });
const runtimeParameter = JSON.stringify([
    { R_CUSTOMER: 'R_CUSTOMER' },
    { PROFILESHIPTOLOOKUP: 'PROFILESHIPTOLOOKUP' },
  ]);
const shipTo = IDShipToLookupLayout({
    runtimeParameter
});

const runtimeParameterAltShipTo = JSON.stringify([
    { R_CUSTOMER: 'R_CUSTOMER' },
  ]);
const altShipToTo = IDSynonymsLookupLayout({
    runtimeParameterAltShipTo
});

const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "CREATIONDATETIME",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Creation Date Time",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CREATIONUSERID",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Creation User Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LASTUPDATEDATETIME",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Last Update Date Time",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LASTUPDATEUSERID",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Last Update User Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "COMPANYID",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Company Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "MODULE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Module",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RECORDTYPE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Record Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "TRANSACTIONNUMBER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Transaction #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TRANSACTIONDATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Transaction Date",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "INVOICEDATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Invoice Date",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TRANSACTIONDUEDATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Transaction Due Date",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PURCHASEORDERNUMBER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Purchase Order Number",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "PRICELEVEL",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Price Level",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "PICKSTATUS",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Pick Status",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DISCOUNTTYPE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Discount Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ORDERSIGNEDFLAG",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Order Signed",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "REFERENCE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "COMMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Comment",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "SHIPPINGDATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Ship Date",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SHIPPERCOMMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Shipper Comment",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "TRUCKREFERENCE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Truck Reference",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TRUCKARRIVALDATETIME",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Truck Arrival Date Time",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TRUCKDEPARTDATETIME",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Truck Depart Date Time",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TRUCKCOMMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Truck Comment",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PRINTINVOICE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Print Invoice",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PRINTBOL",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Print BOL",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PRINTDELIVERYNOTIFICATION",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Print Delivery Notification",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PRINTORDERACKNOWLEDGEMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Print Order Acknowledgement",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SENDFAX",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Send Fax",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SENDEMAIL",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Send Email",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },


            {
                "name": "CANCELDATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Cancel Date",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CANCELCOMMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Cancel Comment",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "INVENTOTYAVAILABILITYSTATUS",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Inventory Availability Status",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "USERDEFINEDDATE_1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 1",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_2",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 2",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_3",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 3",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_4",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 4",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_5",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 5",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_6",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 6",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_7",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 7",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_8",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 8",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_9",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 9",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_10",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 10",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 1",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_2",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 2",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_3",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 3",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_4",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 4",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_5",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 5",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_6",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 6",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_7",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 7",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_8",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 8",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_9",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 9",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_10",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 10",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCOMMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Comment",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DISCOUNTPERCENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Discount Percent",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PARTIALSHIPMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Partial Shipment",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CREDITREVIEWDATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Credit Review Date",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CREDITREVIEWCOMMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Credit Review Comment",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SALESMETHOD",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Sales Method",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "REASONCODE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reason Code",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "FISCALPERIOD",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Fiscal Period",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "FISCALYEAR",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Fiscal Year",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "COMMITDATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Commit Date",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SALESCOMMISIONADVANCE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Sales Commission Advance",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PRINTPICKINGSLIP",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Print Picking Slip",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PRINTPACKINGSLIP",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Print Packing Slip",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "FMTRIPNUMBER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "FM Trip Number",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "FMPUSTOPNUMBER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "FM PU Stop Number",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "COMMISSIONTYPE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Commission Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "COMMISSIONTRANSACTIONPAYGROUP",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Commission Transaction Pay Group",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "COMMISSIONSETTLEMENTGROUP",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Commission Settlement Group",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "FMTRANSFERFLAG",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "FM Transfer Flag",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CURRENCYBASIS",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Currency Basis",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "CURRENCYCONVERSIONFACTOR",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Currency Conversion Factor",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CURRENCYCONVERSIONDATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Currency Conversion Date",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "StageFlag",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Stage",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "StatusFlag",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "BACKORDERFLAG",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Backorder Flag",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TRANSACTIONSUBTYPE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Transaction Subtype",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },


        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "DEFAULTFREIGHTRATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Default Freight Rate",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "MISCFEETYPE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Misc Fee Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CHARGEANDHOLDTYPE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Charge And Hold Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_11",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 11",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_12",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 12",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_13",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 13",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_14",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 14",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_15",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 15",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_16",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 16",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_17",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 17",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_18",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 18",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_19",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 19",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_20",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 20",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_11",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 11",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_12",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 12",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_13",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 13",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_14",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 14",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_15",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 15",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_16",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 16",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_17",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 17",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_18",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 18",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_19",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 19",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_20",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Date 20",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_11",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 11",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_12",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 12",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_13",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 13",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_14",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 14",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_15",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 15",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_16",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 16",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_17",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 17",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_18",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 18",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_19",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 19",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_20",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Quantity 20",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_11",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 11",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_12",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 12",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_13",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 13",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_14",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 14",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_15",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 15",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_16",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 16",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_17",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 17",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_18",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 18",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_19",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 19",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_20",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 20",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TOTALFREIGHTRATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Total Freight Rate",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "CREDITSTATUSREVIEW",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Credit Status Review",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CREDITREVIEWREASON",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Credit Review Reason",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "INVENTORYREVIEW",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Inventory Review",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "REVIEWER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reviewer",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "REVIEWSTAGE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Review Stage",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SETNO",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Set No",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "HOLDATALTERNATEWH",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Hold At Alternate WH",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CREATEORDERATALTERNATEWH",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Create Order At Alternate WH",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RECORD",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Record",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CUSTOMERIDENTITYID",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Customer",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "CUSTOMERADDRESS1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Address1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CUSTOMERADDRESS2",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Address2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CUSTOMERCITY",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "City",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CUSTOMERZIP",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Zip",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CUSTOMERSTATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "State",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CUSTOMERTELEPHONE1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Telephone1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CONTACTID",
                "tableName": "IDMASTER",
                "localizedField": "IDENTITYID",
                "label": "Contact Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CONTACTNAME",
                "tableName": "IDMASTER",
                "localizedField": "NAME",
                "label": "Contact Name",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DEPARTMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Department",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SHIPTOID",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Ship To Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 4,
        "fields": [
            {
                "name": "USERDEFINEDCODE_1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_2",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_3",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 3",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_4",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 4",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_5",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 5",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_6",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 6",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_7",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 7",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_8",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 8",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_9",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 9",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_10",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Code 10",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_2",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_3",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 3",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_4",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 4",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_5",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 5",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_6",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 6",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_7",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 7",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_8",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 8",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_9",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 9",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_10",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "User Defined Reference 10",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "EDITRANSMITFLAG",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "EDI Transmit Flag",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "TRANSACTIONORIGIN",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Transaction Origin",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "COMMITTYPE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Commit Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CURRENCYRATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Currency Rate",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TRANSCURRENCYTYPE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Trans Currency Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PAYCURRENCYTYPE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Pay Currency Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RATETIMING",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Rate Timing",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "FMTRUCKREFERENCE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "FM Truck Reference",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "FMDRIVERREFERENCE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "FM Driver Reference",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "FMTRAILERREFERENCE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "FM Trailer Reference",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "IMPORTFILENAME",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Import File Name",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DEFAULTDETAILDISCOUNT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Default Detail Discount",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CONSIGNMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Consignment",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "EQUIPMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Equipment",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SHIPTONAME",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Ship To Name",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PROFILECODE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Profile",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "IsOpenStatus",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Open Status Only",
                "type": "checkbox",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RCAJOB",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "RCA Job",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "JOB",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Job",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "JOBDESCRIPTION",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Job Description",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RSHIPVIA",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "R Ship Via",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SHIPVIA",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Ship Via",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "BASISMETHOD",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Basis Method",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SALESPERSON1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Salesperson1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SALESPERSON1NAME",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Salesperson1 Name",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SALESPERSON2",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Salesperson2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SALESPERSON2NAME",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Salesperson2 Name",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TAXCODE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Tax Code",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TAXDESC1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Tax Description1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TRANSCURRENCY",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Trans Currency",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TRANSCURRENCYNAME",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Trans Currency Name",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PAYCURRENCY",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Pay Currency",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PAYCURRENCYNAME",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Pay Currency Name",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CONSIGNEEFREIGHTZONECODE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Consignee Freight Zone Code",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TAXDESC2",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Tax Description2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            }
        ]
    }
];
const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
                {
                "name": "RECORD",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Record #:",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true
            },
            {
                "name": "R_PROFILE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Profile:",
                "type": "lookup",
                "layout":OMProfileLayout,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            
            {
                "name": "TRANSACTIONTYPE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Type:",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
             
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "TRANSACTIONNUMBER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Transaction #",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "STAGE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Stage:",
                "type": "select",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true
            },
            
        ]
    },{
        "groupId": 3,
        "label": "Customer",
        "fields": [
            {
                "name": "R_CUSTOMER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Customer:",
                "type": "lookup",
                "layout": customerLayout,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            } ,
            {
                "name": "CUSTOMERNAME",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Name:",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CUSTOMERADDRESS1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Address 1:",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CUSTOMERADDRESS2",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Address 2:",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CUSTOMERCITY",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "City:",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CUSTOMERSTATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "State:",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CUSTOMERZIP",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Zip:",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CUSTOMERCOUNTRY",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Country:",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CUSTOMERTELEPHONE1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Phone:",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CUSTOMERFAX1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Fax:",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CUSTOMEREMAILADDRESS1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Email:",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
                "readOnly": true
            }

        ]
    },
    {
        "groupId": 4,
        "label": "Ship To",
        "fields": [
            {
                "name": "R_SHIPPER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Ship To:",
                "type": "lookup",
                "layout": shipTo,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } ,
            
            {
                "name": "CONSIGNEENAME",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Name:",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CONSIGNEEADDRESS1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Address 1:",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CONSIGNEEADDRESS2",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Address 2:",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CONSIGNEECITY",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "City:",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CONSIGNEESTATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "State:",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CONSIGNEEZIP",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Zip:",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CONSIGNEECOUNTRY",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Country:",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CONSIGNEETELEPHONE1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Phone:",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CONSIGNEEFAX1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Fax:",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
                "readOnly": true
            },
            {
                "name": "CONSIGNEEEMAILADDRESS1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Email:",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
                "readOnly": true
            }

        ]
    },
    
]
const AdditionalLayout = [
    {
        "groupId": 1,
        "label": "Order Information",
        "fields": [
            {
                "name": "STATUS",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Status:",
                "type": "select",
                "options": [],
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "COMMITTYPE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Commit Type:",
                "type": "select",
                "options": [],
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true
            },
            {
                "name": "REASONCODE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reason",
                "type": "lookup",
                "layout": reasonCode,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "PURCHASEORDERNUMBER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "PO Number",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TRANSACTIONDATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Order Date",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "SHIPPINGDATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Ship Date",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            }, {
                "name": "R_SHIPVIA",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Bank",
                "type": "lookup",
                "layout": IDShipViaLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },{
                "name": "R_TAX",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Tax Code",
                "type": "lookup",
                "layout": IDTaxHeaderLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            }, {
                "name": "PRICELEVEL",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Price Level:",
                "type": "select",
                "options": [],
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },{
                "name": "COMMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },{
                "name": "REVIEWSTAGE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Review Stage",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "SETNO",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Set #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
                "readOnly": true,
            },{
                "name": "R_SYNONYMSALTSHIPTO",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Alt Ship To",
                "type": "lookup",
                "layout": altShipToTo,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "CANCELLED",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Cancelled:",
                "type": "select",
                "options": [],
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Invoicing",
        "fields": [
            {
                "name": "INVOICEDATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Invoice Date",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            } ,
            {
                "name": "TRANSACTIONDUEDATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Due Date",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } ,
            {
                "name": "CANCELDATE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Cancel Date",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            } ,{
                "name": "R_TERMS",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Terms Code",
                "type": "lookup",
                "layout": IDTermCodeLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },{
                "name": "R_TERMSDISCOUNT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Terms Disc",
                "type": "lookup",
                "layout": IDDiscountHeaderLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },{
                "name": "REFERENCE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Description",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "Costs",
        "fields": [
            {
                "name": "DISCOUNTTYPE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Discount Type",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            }, {
                "name": "DISCOUNTPERCENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Total Discount",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            } ,{
                "name": "R_DISCOUNTTABLE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Discount Table",
                "type": "lookup",
                "layout": IDDiscountHeaderLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } ,{
                "name": "DEFAULTDETAILDISCOUNT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Item Discount",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Accounting",
        "fields": [
            {
                "name": "R_GLDEPARTMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Department",
                "type": "lookup",
                "layout": ACDepartmentLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_GLFUND",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Fund",
                "type": "lookup",
                "layout": FAFundLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_CAJOB",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Job",
                "type": "lookup",
                "layout": CAJobLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Detail Status",
        "fields": [
            {
                "name": "RecordCount",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Total Lines",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            } ,
            {
                "name": "QuantityOrderedSum",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Ordered Units",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            } ,
            {
                "name": "QuantityShippedSum",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Shipped Units",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            } ,
            {
                "name": "QuantityBackOrderSum",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "BO Units",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            } 
        ]
    },
    {
        "groupId": 5,
        "label": "Back Order Information",
        "fields": [
            {
                "name": "BACKORDERFLAG",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Back Order",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "BackOrderTransactionNumber",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Transaction#",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }  
        ]
    }

];
const TripsLayout = [
    {
        "groupId": 1,
        "label": "Deposits",
        "fields": [
                {
                "name": "R_FMDPPROFILE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "DO Profile",
                "type": "lookup",
                "layout":FMLayouts,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true
            },
            {
                "name": "R_FMSHIPPER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Shipper",
                "type": "lookup",
                "layout":IDShipperLookupLayout({valueExpr:'id',displayExpr:'identityid'}),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "FMTRANSFERFLAG",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "FM Transfer",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TRUCKCOMMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Contact Info",
        "fields": [
            {
                "name": "FMTRIPNUMBER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Trip Number",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_EQUIPMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Equipment",
                "type": "lookup",
                "layout":IDEquipmentLookupLayout({equipmenttype:'P'}),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "EQUIPMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Equip Type",
                "type": "lookup",
                "layout":IDCodesLookupLayout({codeType: 'T0' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TRUCKREFERENCE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "AES/B-13#",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "FMPUSTOPNUMBER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Stop Number",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_TRUCK",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "AES/B-13 #",
                "type": "lookup",
                "layout":IDEquipmentLookupLayout({equipmenttype: 'P' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "FMTRUCKREFERENCE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Truck Reference",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_DRIVER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Driver",
                "type": "lookup",
                "layout":IDDriverLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "FMDRIVERREFERENCE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Driver Reference",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_TRAILER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Trailer",
                "type": "lookup",
                "layout":IDEquipmentLookupLayout({equipmenttype:'T',colName:"Trailer"}),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "FMTRAILERREFERENCE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Trailer Reference",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TRUCKARRIVALDATETIME",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Arrival",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TRUCKDEPARTDATETIME",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Departure",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TRIPWEIGHT",
                "localizedField":"WEIGHTORDERED",
                "tableName": "FMDISPATCHOBJECT",
                "label": "Weight",
                "type": "number", "format": "#,###0",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true
            },
            {
                "name": "TRIPCUBES",
                "localizedField":"CUBESORDERED",
                "tableName": "FMDISPATCHOBJECT",
                "label": "Cubes",
                "type": "number", "format": "#,###0",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true
            },
        ]
    }
    
]
const MiscLayout = [
  {
    "groupId": 1,
    "label": "Credit Information",
    "fields": [
      { "name": "CREDITSTATUSREVIEW", "tableName": "OMTRANSACTIONHEADER", "label": "Review", "type": "select", "required": false, "visible": true },
      { "name": "R_CREDITREVIEWBY", "tableName": "OMTRANSACTIONHEADER", "label": "Review By", "type": "lookup","layout":ApproverLookupLayout, "required": false, "visible": true },
      { "name": "CREDITREVIEWDATE", "tableName": "OMTRANSACTIONHEADER", "label": "Review Date", "type": "datetime", "required": false, "visible": true },
      { "name": "CREDITREVIEWCOMMENT", "tableName": "OMTRANSACTIONHEADER", "label": "Comment", "type": "textarea", "required": false, "visible": true },
      { "name": "CREDITREVIEWREASON", "tableName": "OMTRANSACTIONHEADER", "label": "Review Reason", "type": "textarea", "required": false, "visible": true }
    ]
  },
    {
    "groupId": 7,
    "label": "Price Schedule In Use",
    "fields": [
      { "name": "PriceScheduleCode", "tableName": "OMTRANSACTIONHEADER", "label": "Price Sched.", "type": "text", "required": false, "visible": true,"readOnly": true },
      { "name": "CONSIGNEEFREIGHTZONECODE", "tableName": "OMTRANSACTIONHEADER", "label": "Cons Frt Zone", "type": "text", "required": false, "visible": true,"readOnly": true },
      { "name": "Source", "tableName": "OMTRANSACTIONHEADER", "label": "Source", "type": "text", "required": false, "visible": true,"readOnly": true },
      { "name": "ApplyMethod", "tableName": "OMTRANSACTIONHEADER", "label": "Apply Method", "type": "text", "required": false, "visible": true,"readOnly": true }
    ]
  },
  {
    "groupId": 2,
    "label": "Non-Consignment",
    "fields": [
      { "name": "HOLDATALTERNATEWH", "tableName": "OMTRANSACTIONHEADER", "label": "Hold at Alt WH", "type": "select", "required": false, "visible": true },
      { "name": "CREATEORDERATALTERNATEWH", "tableName": "OMTRANSACTIONHEADER", "label": "Create Order at", "type": "select", "required": false, "visible": true }
    ]
  },

  {
    "groupId": 4,
    "label": "Weights",
    "fields": [
      { "name": "GrossWeight", "tableName": "OMTRANSACTIONHEADER", "label": "Gross Weight", "type": "number", "required": false, "visible": true,"readOnly":true },
      { "name": "NetWeight", "tableName": "OMTRANSACTIONHEADER", "label": "Net Weight", "type": "number", "required": false, "visible": true,"readOnly":true }
    ]
  },
    {
    "groupId": 3,
    "label": "Consignment Order",
    "fields": [
      { "name": "CONSIGNMENT", "tableName": "OMTRANSACTIONHEADER", "label": "Consignment", "type": "select", "required": false, "visible": true }
    ]
  },
  {
    "groupId": 5,
    "label": "Charge & Hold",
    "fields": [
      { "name": "CHARGEANDHOLDTYPE", "tableName": "OMTRANSACTIONHEADER", "label": "C_H_Type", "type": "select", "required": false, "visible": true }
    ]
  },
  {
    "groupId": 6,
    "label": "Freight Rate Zone Override",
    "fields": [
      { "name": "R_ZONEFREIGHTRATEOVERRIDE", "tableName": "OMTRANSACTIONHEADER", "label": "Frt Rate Zone", "type": "lookup","layout":ZoneTabelCodeLookup({codeType:'119'}), "required": false, "visible": true }
    ]
  },

  {
    "groupId": 8,
    "label": "Inventory Review",
    "fields": [
      { "name": "INVENTORYREVIEW", "tableName": "OMTRANSACTIONHEADER", "label": "Inv Review", "type": "select", "required": false, "visible": true }
    ]
  },
  {
    "groupId": 9,
    "label": "Order Signed / Partial Ship",
    "fields": [
      { "name": "ORDERSIGNEDFLAG", "tableName": "OMTRANSACTIONHEADER", "label": "Order Signed", "type": "select", "required": false, "visible": true },
      { "name": "PARTIALSHIPMENT", "tableName": "OMTRANSACTIONHEADER", "label": "Partial Ship", "type": "select", "required": false, "visible": true }
    ]
  },
  {
    "groupId": 10,
    "label": "Notify Someone",
    "fields": [
      { "name": "R_NOTIFYPARTY", "tableName": "OMTRANSACTIONHEADER", "label": "This Person", "type": "lookup","layout": NotifyPartyLookupLayout,"required": false, "visible": true },
      { "name": "R_PATRON", "tableName": "OMTRANSACTIONHEADER", "label": "Patron ID", "type": "lookup","layout":PatronLookupLayout, "required": false, "visible": true }
    ]
  },
  {
    "groupId": 11,
    "label": "Agent Information",
    "fields": [
      { "name": "R_AGENT", "tableName": "OMTRANSACTIONHEADER", "label": "Agent", "type": "lookup","layout":IDLookupLayout, "required": false, "visible": true }
    ]
  },
  {
    "groupId": 12,
    "label": "Default Location WH",
    "fields": [
      { "name": "R_PRIMARYDEFAULTWH", "tableName": "OMTRANSACTIONHEADER", "label": "Warehouse", "layout":IDWarehouseLookupLayout, "type": "lookup", "required": false, "visible": true },
      { "name": "R_SECONDARYDEFAULTWH", "tableName": "OMTRANSACTIONHEADER", "label": "Secondary","layout":IDWarehouseLookupLayout,  "type": "lookup", "required": false, "visible": true }
    ]
  },
  {
    "groupId": 13,
    "label": "Import File",
    "fields": [
      { "name": "IMPORTFILENAME", "tableName": "OMTRANSACTIONHEADER", "label": "Import File", "type": "text", "required": false, "visible": true }
    ]
  }
]
const CommissionLayout = [
  {
    "groupId": 1,
    "label": "Credit Information",
    "fields": [
      { "name": "COMMISSIONTYPE", "tableName": "OMTRANSACTIONHEADER", "label": "Type", "type": "select", "required": false, "visible": true },
      { "name": "COMMISSIONSETTLEMENTGROUP", "tableName": "OMTRANSACTIONHEADER", "label": "Settle Group", "type": "lookup","layout":CodeLookup({codeType:'02'}), "required": false, "visible": true },
      { "name": "R_SALESPERSON_1", "tableName": "OMTRANSACTIONHEADER", "label": "Expense 1", "type": "lookup","layout":IDParticipantLookupLayout, "required": false, "visible": true },
      { "name": "R_SALESPERSON_2", "tableName": "OMTRANSACTIONHEADER", "label": "Expense 2", "type": "lookup","layout":IDParticipantLookupLayout, "required": false, "visible": true },
      { "name": "R_SALESPERSON_3", "tableName": "OMTRANSACTIONHEADER", "label": "Expense 3", "type": "lookup","layout":IDParticipantLookupLayout, "required": false, "visible": true },
      { "name": "R_SALESPERSON_4", "tableName": "OMTRANSACTIONHEADER", "label": "Expense 4", "type": "lookup","layout":IDParticipantLookupLayout, "required": false, "visible": true },
      { "name": "R_SALESPERSON_5", "tableName": "OMTRANSACTIONHEADER", "label": "Expense 5", "type": "lookup","layout":IDParticipantLookupLayout, "required": false, "visible": true },
    ]
  },
    {
    "groupId": 7,
    "label": "Pay Group",
    "fields": [
      { "name": "COMMISSIONTRANSACTIONPAYGROUP", "tableName": "OMTRANSACTIONHEADER", "label": "Transaction", "type": "lookup","layout":IDCodesLookupLayout({codeType:'AD'}), "required": false, "visible": true },
    ]
  },
  {
    "groupId": 2,
    "label": "Commission Expense Account",
    "fields": [
      { "name": "R_CEACCOUNT", "tableName": "OMTRANSACTIONHEADER", "label": "Account #", "type": "lookup","layout":AccountLookup, "required": false, "visible": true },
    ]
  },
]
const CodesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDCODE_1",
                "localizedField": "USERDEFINEDCODE_1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 1",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '02' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_2",
                "localizedField": "USERDEFINEDCODE_2",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 2",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '03' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_3",
                "localizedField": "USERDEFINEDCODE_3",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 3",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '04' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_4",
                "localizedField": "USERDEFINEDCODE_4",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 4",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '05' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_5",
                "localizedField": "USERDEFINEDCODE_5",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 5",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '06' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_6",
                "localizedField": "USERDEFINEDCODE_6",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 6",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '07' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_7",
                "localizedField": "USERDEFINEDCODE_7",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 7",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '08' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_8",
                "localizedField": "USERDEFINEDCODE_8",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 8",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '09' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_9",
                "localizedField": "USERDEFINEDCODE_9",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 9",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '10' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_10",
                "localizedField": "USERDEFINEDCODE_10",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 10",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '11' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
                        {
                "name": "USERDEFINEDCODE_11",
                "localizedField": "USERDEFINEDCODE_11",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 11",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '23' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_12",
                "localizedField": "USERDEFINEDCODE_12",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 12",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '24' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_13",
                "localizedField": "USERDEFINEDCODE_13",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 13",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '25' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_14",
                "localizedField": "USERDEFINEDCODE_14",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 14",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '26' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_15",
                "localizedField": "USERDEFINEDCODE_15",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 15",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '27' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_16",
                "localizedField": "USERDEFINEDCODE_16",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 16",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '28' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_17",
                "localizedField": "USERDEFINEDCODE_17",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 17",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '29' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_18",
                "localizedField": "USERDEFINEDCODE_18",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 18",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '30' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_19",
                "localizedField": "USERDEFINEDCODE_19",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 19",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '31' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_20",
                "localizedField": "USERDEFINEDCODE_20",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Code 20",
                "type": "lookup", 
                "layout": OMCodesLookupLayout({ codeType: '32' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDDATE_1",
                "localizedField": "USERDEFINEDDATE_1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_2",
                "localizedField": "USERDEFINEDDATE_2",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_3",
                "localizedField": "USERDEFINEDDATE_3",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_4",
                "localizedField": "USERDEFINEDDATE_4",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_5",
                "localizedField": "USERDEFINEDDATE_5",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_6",
                "localizedField": "USERDEFINEDDATE_6",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_7",
                "localizedField": "USERDEFINEDDATE_7",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_8",
                "localizedField": "USERDEFINEDDATE_8",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_9",
                "localizedField": "USERDEFINEDDATE_9",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_10",
                "localizedField": "USERDEFINEDDATE_10",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
                        {
                "name": "USERDEFINEDDATE_11",
                "localizedField": "USERDEFINEDDATE_11",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 11",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_12",
                "localizedField": "USERDEFINEDDATE_12",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 12",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_13",
                "localizedField": "USERDEFINEDDATE_13",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 13",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_14",
                "localizedField": "USERDEFINEDDATE_14",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 14",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_15",
                "localizedField": "USERDEFINEDDATE_15",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 15",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_16",
                "localizedField": "USERDEFINEDDATE_16",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 16",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_17",
                "localizedField": "USERDEFINEDDATE_17",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 17",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_18",
                "localizedField": "USERDEFINEDDATE_18",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 18",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_19",
                "localizedField": "USERDEFINEDDATE_19",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 19",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_20",
                "localizedField": "USERDEFINEDDATE_20",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Date 20",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDQUANTITY_1",
                "localizedField": "USERDEFINEDQUANTITY_1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 1",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_2",
                "localizedField": "USERDEFINEDQUANTITY_2",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 2",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_3",
                "localizedField": "USERDEFINEDQUANTITY_3",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 3",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_4",
                "localizedField": "USERDEFINEDQUANTITY_4",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 4",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_5",
                "localizedField": "USERDEFINEDQUANTITY_5",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 5",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_6",
                "localizedField": "USERDEFINEDQUANTITY_6",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 6",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_7",
                "localizedField": "USERDEFINEDQUANTITY_7",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 7",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_8",
                "localizedField": "USERDEFINEDQUANTITY_8",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 8",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_9",
                "localizedField": "USERDEFINEDQUANTITY_9",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 9",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_10",
                "localizedField": "USERDEFINEDQUANTITY_10",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 10",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            
            {
                "name": "USERDEFINEDQUANTITY_11",
                "localizedField": "USERDEFINEDQUANTITY_11",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 11",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_12",
                "localizedField": "USERDEFINEDQUANTITY_12",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 12",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_13",
                "localizedField": "USERDEFINEDQUANTITY_13",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 13",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_14",
                "localizedField": "USERDEFINEDQUANTITY_14",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 4",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_15",
                "localizedField": "USERDEFINEDQUANTITY_15",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 15",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_16",
                "localizedField": "USERDEFINEDQUANTITY_16",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 16",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_17",
                "localizedField": "USERDEFINEDQUANTITY_17",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 17",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_18",
                "localizedField": "USERDEFINEDQUANTITY_18",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 18",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_19",
                "localizedField": "USERDEFINEDQUANTITY_19",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 19",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_20",
                "localizedField": "USERDEFINEDQUANTITY_20",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Quantity 20",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        

        ]
    }
]
const RefrencesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDREFERENCE_1",
                "localizedField": "USERDEFINEDREFERENCE_1",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_2",
                "localizedField": "USERDEFINEDREFERENCE_2",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_3",
                "localizedField": "USERDEFINEDREFERENCE_3",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_4",
                "localizedField": "USERDEFINEDREFERENCE_4",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_5",
                "localizedField": "USERDEFINEDREFERENCE_5",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_6",
                "localizedField": "USERDEFINEDREFERENCE_6",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_7",
                "localizedField": "USERDEFINEDREFERENCE_7",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_8",
                "localizedField": "USERDEFINEDREFERENCE_8",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_9",
                "localizedField": "USERDEFINEDREFERENCE_9",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_10",
                "localizedField": "USERDEFINEDREFERENCE_10",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            
            {
                "name": "USERDEFINEDREFERENCE_11",
                "localizedField": "USERDEFINEDREFERENCE_11",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 11",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_12",
                "localizedField": "USERDEFINEDREFERENCE_12",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 12",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_13",
                "localizedField": "USERDEFINEDREFERENCE_13",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 13",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_14",
                "localizedField": "USERDEFINEDREFERENCE_14",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 14",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_15",
                "localizedField": "USERDEFINEDREFERENCE_15",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 15",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_16",
                "localizedField": "USERDEFINEDREFERENCE_16",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 16",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_17",
                "localizedField": "USERDEFINEDREFERENCE_17",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 17",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_18",
                "localizedField": "USERDEFINEDREFERENCE_18",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 18",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_19",
                "localizedField": "USERDEFINEDREFERENCE_19",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 19",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_20",
                "localizedField": "USERDEFINEDREFERENCE_20",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Reference 20",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        
        ]
    },
        {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDCOMMENT",
                "localizedField": "USERDEFINEDCOMMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },]
        }
]
const PrintFlagsLayout = [
    {
        "groupId": 1,
        "label": "Print Flags",
        "fields": [
            {
                "name": "SENDFAX",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Send Fax",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "SENDEMAIL",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Send E-Mail",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "PRINTORDERACKNOWLEDGEMENT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Order Acknowledgement",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PRINTPICKINGSLIP",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Picking Slip",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "PRINTDELIVERYNOTIFICATION",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Notification",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PRINTPACKINGSLIP",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Packing Slip",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "PRINTBOL",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Print BOL",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "PRINTINVOICE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Print Invoice",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "EDITRANSMITFLAG",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "EDI Sent",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]

export {
    SearchLayout,
    PrimaryLayout,
    AdditionalLayout,
    TripsLayout,
    MiscLayout,
    CommissionLayout,
    CodesLayout,
    RefrencesLayout,
    PrintFlagsLayout
}